function updateFormError(errors, form) {
    const keys = Object.keys(errors);
    keys.forEach((key) => {
        form.pushErrorDetails(key, errors[key]);
    });
}

export default updateFormError;
